/**
 * The workflow's one-sentence reading, with the values it turns on picked out.
 * Two consumers today — the editor's card and the list's second line — so it
 * takes its size from the caller rather than owning a type scale.
 */
import type { SummaryToken } from './summarize.js';
import { summaryText } from './summarize.js';

export const SummarySentence = ({
  tokens,
  className,
}: {
  tokens: SummaryToken[];
  className?: string;
}) => (
  <p className={className} title={summaryText(tokens)}>
    {tokens.map((t, i) =>
      t.strong ? (
        <span key={i} className="font-medium text-ink">
          {t.text}
        </span>
      ) : (
        <span key={i}>{t.text}</span>
      ),
    )}
  </p>
);
